import { ExistingSystemType } from 'data/types';

const DEFAULT_SYSTEM_NAME_PATTERN = /^System \d+$/;

export function defaultExistingSystemName(ordinal: number): string {
  return `System ${ordinal}`;
}

export function nextExistingSystemName(
  existingSystems: ExistingSystemType[]
): string {
  const takenNames = new Set(existingSystems.map((system) => system.name));
  let ordinal = 1;
  while (takenNames.has(defaultExistingSystemName(ordinal))) {
    ordinal += 1;
  }
  return defaultExistingSystemName(ordinal);
}

export function renumberDefaultExistingSystemNames(
  existingSystems: ExistingSystemType[]
): ExistingSystemType[] {
  return existingSystems.map((system, index) =>
    DEFAULT_SYSTEM_NAME_PATTERN.test(system.name)
      ? { ...system, name: defaultExistingSystemName(index + 1) }
      : system
  );
}
